import React, { useState } from 'react';
import CircleButton, {
  getCircleButtonClass,
} from 'components/v2/buttons/CircleButton';
import { Calendar } from 'lucide-react';
import CheckIcon from 'components/v2/icons/CheckIcon';
import { useTranslation } from 'react-i18next';
import { sluggify } from 'utils/localization/utils';
import ShipmentDatesModal from 'components/modules/shipments/ShipmentDatesModal';
import { showToast } from 'stores/ToastStore';

export default function DateNextSteps({ item, shipment }) {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);

  const renderIcon = () => {
    return !item.complete ? (
      <Calendar className="w-5 h-5" />
    ) : (
      <div
        data-testid="div-bba6d2d9"
        className={getCircleButtonClass({ size: 'small', color: 'brand' })}
      >
        <CheckIcon />
      </div>
    );
  };

  const handleNextStepsDateSave = () => {
    showToast(t('SHIPMENT_NEXT_STEPS_UPDATE_SUCCESSFUL'), null, 'success');
    setShowModal(false);
  };

  const handleNextStepsDateSaveFail = (e) => {
    showToast(t('FAILED_SHIPMENT_NEXT_STEPS_UPDATE'), null, 'error');
    setShowModal(false);
  };

  return (
    <div data-testid="div-c4d45ba8">
      <div
        data-testid="div-2447baec"
        className="flex justify-between text-sm text-gray-700  py-1 items-center"
      >
        <span data-testid="span-ae954506">{t(sluggify(item.field))}</span>

        <CircleButton
          dataTestId="CircleButton-0eaba379"
          size="small"
          disabled={item.complete}
          onClick={() => setShowModal(true)}
        >
          {renderIcon()}
        </CircleButton>
      </div>
      {showModal && (
        <ShipmentDatesModal
          field={item.field}
          currentFieldValue={shipment[item.field]}
          shipment={shipment}
          onSuccess={handleNextStepsDateSave}
          onFail={handleNextStepsDateSaveFail}
          onHide={() => setShowModal(false)}
          show={showModal}
        />
      )}
    </div>
  );
}
